import { useState } from 'react';
import { Card } from '@agro1desenvolvimento/react-components';
import GerenciadorImagens, { ImagemFormulario } from '../../GerenciadorImagens';

interface Props {
  produtor: string;
  idDaAmostra: string;
  numeroRemessa: string;
  especie: string;
  lote: string;
  safra: string;
  nomeCientifico: string;
  cultivar: string;
  categoria: string;
  dataEntrada: Date | null;
  dataAmostragem: Date | null;
  status: string;
  imagens: ImagemFormulario[];
  onAdicionarImagem: (imagem: Omit<ImagemFormulario, 'id' | 'timestamp'>) => void;
  onRemoverImagem: (imagemId: string) => void;
  loadingImagens?: boolean;
}

export default function FormularioCanteiroAreiaHeader({
  produtor,
  idDaAmostra,
  numeroRemessa,
  especie,
  lote,
  safra,
  nomeCientifico,
  cultivar,
  categoria,
  dataEntrada,
  dataAmostragem,
  status,
  imagens,
  onAdicionarImagem,
  onRemoverImagem,
  loadingImagens,
}: Props) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const formatDate = (date: Date | null): string => {
    if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
      return '';
    }
    return date.toLocaleDateString('pt-BR');
  };

  const getStatusClass = () => {
    if (status.toLowerCase() === 'iniciado') {
      return 'iniciado';
    } if (status.toLowerCase() === 'realizado') {
      return 'realizado';
    } if (status.toLowerCase() === 'pendente') {
      return 'pendente';
    }
    return 'pendente';
  };

  return (
    <Card className="formulario-canteiro-areia-header">
      <div className="header">
        <h2 className="title">Amostra - {idDaAmostra}</h2>
        <span className={`status ${getStatusClass()}`}>{status}</span>
      </div>

      {!isCollapsed && (
        <div className="grid">
          <div className="field">
            <label>Requerente</label>
            <span>{produtor}</span>
          </div>
          <div className="field">
            <label>N° da Remessa</label>
            <span>{numeroRemessa}</span>
          </div>
          <div className="field">
            <label>Espécie</label>
            <span>{especie}</span>
          </div>
          <div className="field">
            <label>Lote</label>
            <span>{lote}</span>
          </div>
          <div className="field">
            <label>Safra</label>
            <span>{safra}</span>
          </div>
          <div className="field">
            <label>Nome Científico</label>
            <span>{nomeCientifico}</span>
          </div>
          <div className="field">
            <label>Cultivar</label>
            <span>{cultivar}</span>
          </div>
          <div className="field">
            <label>Categoria</label>
            <span>{categoria}</span>
          </div>
          <div className="field">
            <label>Data de Entrada</label>
            <span>{formatDate(dataEntrada)}</span>
          </div>
          <div className="field">
            <label>Data de Amostragem</label>
            <span>{formatDate(dataAmostragem)}</span>
          </div>
        </div>
      )}

      {!isCollapsed && (
        <GerenciadorImagens
          imagens={imagens}
          onAdicionarImagem={onAdicionarImagem}
          onRemoverImagem={onRemoverImagem}
          loading={loadingImagens}
          maxImagens={5}
        />
      )}

      <button
        type="button"
        className={`hide-button ${isCollapsed ? 'collapsed' : ''}`}
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <i className={`fas fa-chevron-${isCollapsed ? 'down' : 'up'}`} />
        Esconder
      </button>
    </Card>
  );
}
